/* Female Angle Listicle — countdown, FAQ accordion, sticky-bar scroll */
(function () {
  if (window.__falInit) return;
  window.__falInit = true;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- Countdown ---------- */
  function initTimers(root) {
    var timers = (root || document).querySelectorAll('[data-fal-timer]:not([data-fal-ready])');
    timers.forEach(function (el) {
      el.setAttribute('data-fal-ready', '1');
      var mode = el.getAttribute('data-mode') || 'midnight';
      var hours = parseFloat(el.getAttribute('data-hours') || '12');
      var prefix = el.getAttribute('data-prefix') || '';
      var key = 'fal-timer-end-' + (el.getAttribute('data-key') || 'default');
      var end;

      function nextEnd() {
        var now = new Date();
        if (mode === 'evergreen') {
          return now.getTime() + hours * 3600 * 1000;
        }
        var m = new Date(now);
        m.setHours(24, 0, 0, 0);
        return m.getTime();
      }

      if (mode === 'evergreen') {
        try { end = parseInt(localStorage.getItem(key), 10); } catch (e) { end = NaN; }
        if (!end || end < Date.now()) {
          end = nextEnd();
          try { localStorage.setItem(key, String(end)); } catch (e) {}
        }
      } else {
        end = nextEnd();
      }

      function tick() {
        var diff = Math.max(0, end - Date.now());
        if (diff <= 0) {
          end = nextEnd();
          if (mode === 'evergreen') { try { localStorage.setItem(key, String(end)); } catch (e) {} }
          diff = end - Date.now();
        }
        var s = Math.floor(diff / 1000);
        var h = Math.floor(s / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        el.textContent = prefix + pad(h) + ':' + pad(m) + ':' + pad(sec);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- FAQ: one open at a time (optional) ---------- */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-fal-faq]:not([data-fal-ready])').forEach(function (list) {
      list.setAttribute('data-fal-ready', '1');
      if (list.getAttribute('data-single') !== 'true') return;
      var items = list.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---------- Smooth scroll to the bundle section ---------- */
  function scrollToTarget(id) {
    var target = document.getElementById(id);
    if (!target) return false;
    var top = target.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-fal-scroll]');
    if (!trigger) return;
    var id = (trigger.getAttribute('data-fal-scroll') || '').replace(/^#/, '');
    if (id && scrollToTarget(id)) {
      e.preventDefault();
    }
  });

  function init(root) { initTimers(root); initFaq(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
